import { createAction } from '@reduxjs/toolkit';
import { storeName } from '../config';

export const updateUserTotalScore = createAction<{
  userId: string | undefined;
  totalScore: number | null;
}>(`${storeName}/updateUserTotalScore`);
